import { Primitive } from '../Primitive';
import { Type } from '../Type';
export class Polyline3D extends Primitive {
    points;
    constructor(points) {
        super(Type.Polyline3D);
        this.points = points;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUG9seWxpbmUzRC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9saWIvdHlwZXMvZ2VvbWV0cnlfM2QvUG9seWxpbmUzRC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsU0FBUyxFQUFFLE1BQU0sY0FBYyxDQUFBO0FBQ3hDLE9BQU8sRUFBRSxJQUFJLEVBQUUsTUFBTSxTQUFTLENBQUE7QUFJOUIsTUFBTSxPQUFPLFVBQVcsU0FBUSxTQUFTO0lBQ3ZDLE1BQU0sQ0FBVztJQUVqQixZQUFZLE1BQWlCO1FBQzNCLEtBQUssQ0FBQyxJQUFJLENBQUMsVUFBVSxDQUFDLENBQUE7UUFDdEIsSUFBSSxDQUFDLE1BQU0sR0FBRyxNQUFNLENBQUE7SUFDdEIsQ0FBQztDQUNGIn0=